// @ts-nocheck
import { IKanbanSettingModel } from '../models/KanbanSettingModel';

export enum KanbanActions {
  FETCH_KANBAN_ROUTES = 'FETCH_KANBAN_ROUTES',
  FETCH_KANBAN_ROUTES_SUCCESS = 'FETCH_KANBAN_ROUTES_SUCCESS',
  FETCH_KANBAN_ROUTES_ERROR = 'FETCH_KANBAN_ROUTES_ERROR',
}

export interface KanbanState {
  routes: IKanbanSettingModel;
  loading: boolean;
  error: string | null;
}

interface FetchKanbanRoutesAction {
  type: KanbanActions.FETCH_KANBAN_ROUTES;
  payload?: any;
}

interface FetchKanbanRoutesSuccessAction {
  type: KanbanActions.FETCH_KANBAN_ROUTES_SUCCESS;
  payload: IKanbanSettingModel;
}

interface FetchKanbanRoutesErrorAction {
  type: KanbanActions.FETCH_KANBAN_ROUTES_ERROR;
  payload: string;
}

export type KanbanAction =
  FetchKanbanRoutesAction | FetchKanbanRoutesSuccessAction | FetchKanbanRoutesErrorAction;

//https://github.com/rcdexta/react-trello?tab=readme-ov-file#publish-events
export type KanbanEventBusHandle = {
  publish: (event: any) => void;
};
